import {Heading, useTheme, VStack} from '@chakra-ui/react'
import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'

interface Props {
  placeholder: string
}

const ServiceGroupPlaceholder = ({placeholder}: Props) => {
  const theme = useTheme()
  const {t} = useTranslation('service-group')

  return (
    <VStack
      w='full'
      p={5}
      spacing={5}
      background={theme.colors.layers.appLevel1}
      borderRadius={theme.radii.big}
      py={40}>
      <Image src='/assets/Arrow.svg' alt='arrow' width={64} height={64} />
      <Heading color={theme.colors.text.light} w='full' textAlign='center'>
        {t(`${placeholder}`)}
      </Heading>
    </VStack>
  )
}
export default ServiceGroupPlaceholder
